module.exports = __webpack_public_path__ + "img/abacus_type_1.b5e5e8a1.png";